module.exports = __webpack_public_path__ + "img/1584224564.937dcca4.jpg";